import { useCallback } from 'react';
import { Modal, Typography } from 'antd';
import { observer } from 'mobx-react-lite';

import {
  NotificationsRender,
  useNotifyFactory,
} from 'app/common/notifications/features/notifications';
import { useAuthStatusWriter } from 'app/railways/domains/auth/features/auth-status';
import { useUserProfileStore } from 'app/railways/domains/profile/features/user-profile-data';
import { Loading } from 'app/ui';
import { useModalState } from 'app/ui/modal';

import { TCredentials } from '../../core';
import { LoginForm } from '../login-form';
import { useSignIn } from '../use-sign-in';

const { Paragraph } = Typography;

export const SignInModal = observer(() => {
  const errorNotify = useNotifyFactory({ behaviour: 'replace_msg' });
  const userProfileStore = useUserProfileStore();
  const authStatusStore = useAuthStatusWriter();
  const [modalState, modalActions] = useModalState(true);

  const signInResource = useSignIn({
    errorNotify,
    onSuccess: (userData) => {
      userProfileStore.setProfile(userData);
      authStatusStore.allowAccess();
      modalActions.hide();
    },
  });

  const submitForm = useCallback(
    (credentials: TCredentials) => {
      signInResource.send(credentials);
    },
    [signInResource]
  );

  return (
    <Modal
      title="Войдите в аккаунт"
      open={modalState.get()}
      width={348}
      closable={false}
      maskClosable={false}
      footer={null}
    >
      <Loading active={signInResource.isLoading}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <NotificationsRender notifyStore={errorNotify}>
            {(errors) => (
              <div style={{ marginBottom: 16, width: '100%' }}>{errors}</div>
            )}
          </NotificationsRender>

          <Paragraph style={{ textAlign: 'center' }}>
            Войдите в свой аккаунт, чтобы продолжить
          </Paragraph>

          <LoginForm onSubmit={submitForm} />
        </div>
      </Loading>
    </Modal>
  );
});
